<template>
  <van-pull-refresh
    class="content"
    v-model="refreshing"
    @refresh="onRefresh"
    loading-text=" "
  >
    <van-list
      v-model:loading="loading"
      :finished="finished"
      loading-text=" "
      finished-text="中山日报 中山+ 出品"
      @load="onLoad"
      class="content-list"
    >
      <van-cell-group inset class="group-top" v-if="contents.length == 0">
        <van-cell>
          <van-empty class="custom-image" description="无内容" />
        </van-cell>
      </van-cell-group>
      <van-cell-group
        inset
        class="group-top"
        v-for="(item, index) in contents"
        :key="index"
        :item="item"
        :index="index"
        @click="handleClick(item.id)"
      >
        <van-cell class="content-cell">
          <template #title>
            <div class="custom_title">
              <div class="list-title van-multi-ellipsis--l2">
                {{ item.nickname }}
              </div>
              <van-icon name="arrow" color="#FF8831" class="title-more" />
            </div>
            <div class="list-content van-multi-ellipsis--l3">
              {{ item.user_content }}
            </div>
            <van-grid
              v-if="item.images.length === 1"
              class="custom-img2"
              :column-num="1"
              :border="false"
            >
              <van-grid-item
                class="content-image"
                v-for="(image, index) in item.images"
                :key="index"
                :column-num="item.images.length"
              >
                <van-image
                  fit="fit"
                  :src="image"
                  @click="imgClick(item.images, index)"
                  @click.stop
                />
              </van-grid-item>
            </van-grid>
            <van-grid
              v-if="item.images.length === 2 || item.images.length === 4"
              class="custom-img2"
              direction="horizontal"
              square
              :gutter="5"
              :column-num="2"
              :border="false"
            >
              <van-grid-item
                class="content-image"
                v-for="(image, index) in item.images"
                :key="index"
                :column-num="item.images.length"
              >
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="image"
                  @click="imgClick(item.images, index)"
                  @click.stop
                />
              </van-grid-item>
            </van-grid>
            <van-grid
              v-if="
                item.images.length === 3 ||
                item.images.length === 5 ||
                item.images.length === 6
              "
              class="custom-img"
              direction="horizontal"
              square
              :gutter="5"
              :column-num="3"
              :border="false"
            >
              <van-grid-item
                class="content-image"
                v-for="(image, index) in item.images"
                :key="index"
                :column-num="item.images.length"
              >
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="image"
                  @click="imgClick(item.images, index)"
                  @click.stop
                />
              </van-grid-item>
            </van-grid>
            <div v-for="(reply, replyIndex) in item.replys" :key="replyIndex">
              <div class="content-reply">
                <div class="list-title" v-if="tabActive === 'qa'">
                  <span>答</span>
                </div>
                <div
                  :class="
                    tabActive === 'tipoff' ? 'content-text' : 'list-title'
                  "
                  v-else
                >
                  <span>官方回复</span>
                </div>
                中山+
              </div>
              <div class="list-content van-multi-ellipsis--l2">
                {{ reply.official_reply }}
              </div>
            </div>
          </template>
          <template #label>
            <div class="custom_detail">
              <div class="detail_right">
                {{ dealDate(item.createtime) }}
              </div>
              <div class="detail_left">
                <van-button icon="comment" size="normal" style="border: none">
                  评论{{ item.comment_count }}
                </van-button>
                <van-button
                  icon="like"
                  size="normal"
                  style="border: none"
                  :type="item.buttonType"
                  @click="like(item.id, index)"
                  @click.stop
                  plain
                  >{{ item.like }}</van-button
                >
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import {
  List,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  PullRefresh,
  Icon,
  Button,
  Image as VanImage,
  ImagePreview,
  Empty,
} from "vant";
import useDateDiff from "@/composiables/useDateDiff.js";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref, computed } from "vue";
export default {
  name: "ContentCell",
  props: { type: String },
  components: {
    [VanImage.name]: VanImage,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [List.name]: List,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Empty.name]: Empty,
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const page = ref(1);
    const onLoad = () => {
      const params = {
        page: page.value,
        pageSize: 20,
        category: props.type,
      };
      store.dispatch("getContentList", {
        params,
        loading,
        finished,
        refreshing,
      });
      page.value++;
    };

    const onRefresh = () => {
      //清空列表数据
      finished.value = false;

      //重新加载数据
      loading.value = true;
      page.value = 1;
      onLoad();
    };

    const imgClick = (images, index) => {
      ImagePreview({
        images: images,
        startPosition: index,
        closeable: true,
      });
    };

    const like = (id, index) => {
      console.log(id);
      const params = {
        id: id,
        type: 1,
      };
      store.dispatch("contentLike", { params, index });
    };

    const handleClick = (id) => {
      router.push("/detail/" + id);
    };

    const dealDate = (dateString) => {
      return useDateDiff(dateString);
    };

    const handleContent = () => {
      if (props.type == "qa") {
        return store.state.qaContents;
      } else if (props.type == "advice") {
        return store.state.adviceContents;
      } else if (props.type == "tipoff") {
        return store.state.tipoffContents;
      }
    };

    return {
      // category,
      imgClick,
      like,
      handleClick,
      dealDate,
      onLoad,
      loading,
      finished,
      onRefresh,
      refreshing,
      contents: computed(() => handleContent()),
      tabActive: props.type,
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 5vw;
  padding-bottom: 90px;
  --van-pull-refresh-head-text-color: white;
}

.content-list {
  --van-list-text-color: #5190d5;
}
.content-cell {
}
.group-top {
  margin: 0px 20px;
  margin-bottom: 12px;
  background-color: white;
}
.title-more {
  font-weight: bold;
  margin-top: 5px;
}
.list-content {
  font-size: 4vw;
  color: #1c1c1c;
  text-align: left;
  white-space: pre-wrap;
}
.custom-box {
  display: flex;
  flex-wrap: wrap;
}
.custom-img {
  margin: 10px 0;
  width: 100%;
}

.custom-img2 {
  margin: 10px -4px 5px -4px;
  width: 70%;
}

// .custom_imgs {
//   padding-bottom: 10px;
//   display: flex;
//   justify-content: flex-start;
// }

.content-image {
  --van-grid-item-content-padding: 0;
  // display: flex;
  // justify-content: flex-start;
  // flex-wrap: wrap;
}
.img1 {
  /*1张图 */
  width: 66%;
}
.img2 {
  /*2张图*/
  width: 33%;
  margin-right: 10px;
}
.img3 {
  /*3、4、5、6张图*/
  width: 32%;
  margin-right: 10px;
}
.custom_detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 12px;
  // border-top: 1px solid #e0e0e0;
  margin-bottom: 6px;
}
.detail_left {
  display: flex;
  align-items: center;
}
.detail_right {
  color: #aaa5a5;
  font-size: 3.4vw;
}
.van-button--default {
  // font-size: 2.6vw;
  color: #aaa5a5;
  background: var(--van-button-default-background-color);
  border: var(--van-button-border-width) solid
    var(--van-button-default-border-color);
}
.wish-btn {
  padding: 15px 30px;
  text-align: center;
}
.content-reply {
  color: #aaa5a5;
  font-size: 4vw;
  font-weight: 600;
  text-align: left;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 6px;
  span {
    font-size: 3vw;
    width: 64px;
    height: 23px;
    background: #ff8831;
    color: #ffffff;
    border-radius: 12px;
    margin-right: 6px;
    text-align: center;
  }
}
.content-text {
  font-size: 3.8vw;
  display: flex;
}
.custom_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
  padding: 8px 0 10px 0;
  margin-bottom: 10px;
}
.list-title {
  color: #1c1c1c;
  font-size: 3.8vw;
  display: flex;
  span {
    font-size: 3.6vw;
    padding: 0 5px;
    height: 23px;
    background: #ff8831;
    color: #ffffff;
    border-radius: 12px;
    text-align: center;
    margin-right: 15px;
    box-shadow: 1px 1px 5px #dbdada;
  }
}
</style>
